import { get as getCookie } from 'es-cookie';
import constants from './constants';

/*
 * アンケート集計ツールへ送信するデータを生成する
 *
 * @param {object} config - アンケート設定データ
 * @param {string} npsSelectedValues - NPSの選択値
 * @param {string[]} inquirySelectedValues - アンケートの選択値
 * @param {string} inquiryInputValue - アンケート自由解答欄の入力値
 */
const generatePostData = (
  config,
  npsSelectedValue,
  inquirySelectedValues,
  inquiryInputValue
) => {
  const data = {
    c: '楽天',
    l: 'ja',
  };
  data[config.cId.name] = config.cId.value;
  data[config.cUrl.name] = config.cUrl.value;
  const { nps, inquiry } = config;
  const { options, freeInput } = inquiry;

  if (nps && nps.options.length > 0) {
    data[nps.question.name] = nps.question.value;
    // name has always same value.
    // ex) `answers[xxxx_yyyy]`
    data[nps.options[0].name] = npsSelectedValue;
  }

  if (options.length > 0) {
    // option.name has always same value.
    // ex) `answers[xxxx_yyyy][]`
    data[options[0].name] = inquirySelectedValues;
  }
  data[freeInput.name] = inquiryInputValue ? inquiryInputValue : '';

  data[config.ua.name] = window.navigator.userAgent;
  data[config.href.name] = window.location.href;

  const Rp = getCookie(constants.COOKIE_NAME_RP);
  const Rz = getCookie(constants.COOKIE_NAME_RZ);
  data[config.cookieRp.name] =
    typeof Rp === 'string' && Rp.length > 0 ? Rp : '';
  data[config.cookieRz.name] =
    typeof Rz === 'string' && Rz.length > 0 ? Rz : '';

  return data;
};

export default generatePostData;



// WEBPACK FOOTER //
// ./src/components/SurveyToast/businessLogics/generatePostData.js